import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-play-circle",
  templateUrl: "./med-icon-play-circle.component.html",
})
export class MedIconPlayCircleComponent extends SvgMixinComponent {}
